import React, {useCallback, useEffect} from "react";
import AppearanceSelectHint from "./AppearanceSelectHint";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";


const isMobile = (navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i) || window.innerWidth <= 767);

export default function AppearanceSelect (props) {
  const {page} = props;

  const switchMode = useCallback(appearance => {
    const bodyClassList = document.body.classList;
    if (appearance === 'dark') {
      bodyClassList.remove('light-mode');
      bodyClassList.add('dark-mode');
    } else if (appearance === 'light') {
      bodyClassList.remove('dark-mode');
      bodyClassList.add('light-mode');
    }
  });

  const postAppearance = useCallback(appearance => {
    switchMode(appearance);

    const hintElement = document.getElementById("appearance-select-hint");
    if (hintElement instanceof Element) {
      ReactDOM.render(<AppearanceSelectHint />, hintElement);
    }

    const formData = new FormData();
    formData.append("appearance", appearance);
    fetch('/wp-json/she-rest-api/setSiteAppearance', {method: "POST", body: formData})
      .then(response => response.json())
      .then(({appearance}) => { switchMode(appearance); });
  }, []);

  /**
   * Changes 20211111 : not to show the popup, and choose dark mode by default.
   */
  useEffect(() => {
    const classListArr = [...document.body.classList];
    switch (true) {
      case classListArr.includes('dark-mode'):
      case classListArr.includes('light-mode'):
      case page === "single" && isMobile:
        break;
      default: window.setTimeout(() => { postAppearance('dark'); }, 3000);
    }
  }, []);

  return null;
}

AppearanceSelect.propTypes = {
  page: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/AppearanceSelect/index.js